import React, {createContext, useContext, useState} from "react";
import {useGetUnique} from "../hooks";
import {Alert, Container} from "react-bootstrap";

/*
 * Constants and defaults
 */
const variant = {
    info: 'info',
    success: 'success',
    warning: 'warning',
    error: 'danger',
}

const timeout = {
    default: 10000
}


const AlertContext = createContext(null);

export function useAlert() {
    return useContext(AlertContext);
}

export function AlertProvider({children}) {

    const [alerts, setAlerts] = useState([]);
    const {getUniqueId} = useGetUnique("alert");

    // function removeAlert(id) {
    //     // Use function version of useState because we need to access the actual value of alerts
    //     setAlerts(current => current.filter(alert => alert.id !== id));
    // }

    function fadeOut(id) {
        setAlerts(current => current.map(alert => {
            if (alert.id === id)
                alert.show = false; // This will cause
            return alert
        }));
    }

    function create(body, title, options) {
        const {timeout, variant, autoClose} = options;

        const alert = {id: getUniqueId(), variant: variant, title: title, body: body, show: true};
        setAlerts(current => [alert, ...current])

        /* Set auto close */
        if (autoClose === true)
            setTimeout(() => fadeOut(alert.id), timeout);

        return alert.id;
    }

    function success(body, title = "", options = {}) {
        return create(body, title, {timeout: timeout.default, autoClose: true, ...options, variant: variant.success});
    }

    function warn(body, title = "", options = {}) {
        return create(body, title, {timeout: timeout.default, autoClose: true, ...options, variant: variant.warning});
    }

    function error(body, title = "", options = {}) {
        return create(body, title, {timeout: timeout.default, autoClose: true, ...options, variant: variant.error});
    }

    function info(body, title = "", options = {}) {
        return create(body, title, {timeout: timeout.default, autoClose: true, ...options, variant: variant.info});
    }

    function clear(id){
        fadeOut(id)
    }


    const value = {
        success,
        warn,
        error,
        info,
        clear,
    };

    return (
        <AlertContext.Provider value={value}>
            <Container>
                {alerts.map(a => (
                    <Alert className="my-2" key={a.id} variant={a.variant} dismissible show={a.show} onClose={() => fadeOut(a.id)}>
                        {a.title && <Alert.Heading>{a.title}</Alert.Heading>}
                        {a.body}
                    </Alert>
                ))}
            </Container>
            {children}
        </AlertContext.Provider>
    );
}
